/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { ExportExcelFileRes } from '../models/export-excel-file-res';
import { HcDashboardDropdownItem } from '../models/hc-dashboard-dropdown-item';
import { HcDashboardQueryReq } from '../models/hc-dashboard-query-req';
import { HcDashboardResultRes } from '../models/hc-dashboard-result-res';
import { HcDashboardResultSummaryRes } from '../models/hc-dashboard-result-summary-res';
import { MasterCategoryAndSeverityResItem } from '../models/master-category-and-severity-res-item';

@Injectable({ providedIn: 'root' })
export class HealthCheckDashboardService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiHealthCheckDashboardQueryPost()` */
  static readonly ApiHealthCheckDashboardQueryPostPath = '/api/health-check/dashboard/query';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHealthCheckDashboardQueryPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHealthCheckDashboardQueryPost$Response(
    params?: {
      body?: HcDashboardQueryReq
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<HcDashboardResultRes>> {
    const rb = new RequestBuilder(this.rootUrl, HealthCheckDashboardService.ApiHealthCheckDashboardQueryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HcDashboardResultRes>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHealthCheckDashboardQueryPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHealthCheckDashboardQueryPost(
    params?: {
      body?: HcDashboardQueryReq
    },
    context?: HttpContext
  ): Observable<HcDashboardResultRes> {
    return this.apiHealthCheckDashboardQueryPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<HcDashboardResultRes>): HcDashboardResultRes => r.body)
    );
  }

  /** Path part for operation `apiHealthCheckDashboardSummaryPost()` */
  static readonly ApiHealthCheckDashboardSummaryPostPath = '/api/health-check/dashboard/summary';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHealthCheckDashboardSummaryPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHealthCheckDashboardSummaryPost$Response(
    params?: {
      body?: HcDashboardQueryReq
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<HcDashboardResultSummaryRes>> {
    const rb = new RequestBuilder(this.rootUrl, HealthCheckDashboardService.ApiHealthCheckDashboardSummaryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HcDashboardResultSummaryRes>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHealthCheckDashboardSummaryPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHealthCheckDashboardSummaryPost(
    params?: {
      body?: HcDashboardQueryReq
    },
    context?: HttpContext
  ): Observable<HcDashboardResultSummaryRes> {
    return this.apiHealthCheckDashboardSummaryPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<HcDashboardResultSummaryRes>): HcDashboardResultSummaryRes => r.body)
    );
  }

  /** Path part for operation `apiHealthCheckDashboardBookingJobPost()` */
  static readonly ApiHealthCheckDashboardBookingJobPostPath = '/api/health-check/dashboard/booking-job';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHealthCheckDashboardBookingJobPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHealthCheckDashboardBookingJobPost$Response(
    params?: {
      body?: Array<string>
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, HealthCheckDashboardService.ApiHealthCheckDashboardBookingJobPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHealthCheckDashboardBookingJobPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHealthCheckDashboardBookingJobPost(
    params?: {
      body?: Array<string>
    },
    context?: HttpContext
  ): Observable<void> {
    return this.apiHealthCheckDashboardBookingJobPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHealthCheckDashboardMasterCategorySeverityContainPost()` */
  static readonly ApiHealthCheckDashboardMasterCategorySeverityContainPostPath = '/api/health-check/dashboard/master-category-severity-contain';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHealthCheckDashboardMasterCategorySeverityContainPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHealthCheckDashboardMasterCategorySeverityContainPost$Response(
    params?: {
      containText?: string;
      max?: number;
      workGroupIds?: Array<number>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<MasterCategoryAndSeverityResItem>>> {
    const rb = new RequestBuilder(this.rootUrl, HealthCheckDashboardService.ApiHealthCheckDashboardMasterCategorySeverityContainPostPath, 'post');
    if (params) {
      rb.query('containText', params.containText, {});
      rb.query('max', params.max, {});
      rb.query('workGroupIds', params.workGroupIds, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<MasterCategoryAndSeverityResItem>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHealthCheckDashboardMasterCategorySeverityContainPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHealthCheckDashboardMasterCategorySeverityContainPost(
    params?: {
      containText?: string;
      max?: number;
      workGroupIds?: Array<number>;
    },
    context?: HttpContext
  ): Observable<Array<MasterCategoryAndSeverityResItem>> {
    return this.apiHealthCheckDashboardMasterCategorySeverityContainPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MasterCategoryAndSeverityResItem>>): Array<MasterCategoryAndSeverityResItem> => r.body)
    );
  }

  /** Path part for operation `apiHealthCheckDashboardExportPost()` */
  static readonly ApiHealthCheckDashboardExportPostPath = '/api/health-check/dashboard/export';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHealthCheckDashboardExportPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHealthCheckDashboardExportPost$Response(
    params?: {
      body?: HcDashboardQueryReq
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<ExportExcelFileRes>> {
    const rb = new RequestBuilder(this.rootUrl, HealthCheckDashboardService.ApiHealthCheckDashboardExportPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExportExcelFileRes>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHealthCheckDashboardExportPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHealthCheckDashboardExportPost(
    params?: {
      body?: HcDashboardQueryReq
    },
    context?: HttpContext
  ): Observable<ExportExcelFileRes> {
    return this.apiHealthCheckDashboardExportPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportExcelFileRes>): ExportExcelFileRes => r.body)
    );
  }

  /** Path part for operation `apiHealthCheckDashboardDdlListGet()` */
  static readonly ApiHealthCheckDashboardDdlListGetPath = '/api/health-check/dashboard/ddl-list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHealthCheckDashboardDdlListGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHealthCheckDashboardDdlListGet$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<HcDashboardDropdownItem>> {
    const rb = new RequestBuilder(this.rootUrl, HealthCheckDashboardService.ApiHealthCheckDashboardDdlListGetPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HcDashboardDropdownItem>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHealthCheckDashboardDdlListGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHealthCheckDashboardDdlListGet(
    params?: {
    },
    context?: HttpContext
  ): Observable<HcDashboardDropdownItem> {
    return this.apiHealthCheckDashboardDdlListGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<HcDashboardDropdownItem>): HcDashboardDropdownItem => r.body)
    );
  }

}
